import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CustomLoader from '../common/CustomLoader';
import CustomFilterBuilder from './collection/derived-query/CustomFilterBuilder';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
export class AddCollectionFilter extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollections({ projectId, version });
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    this.props.actions.loadProjectPlugins({ projectId, version });
  }

  render() {
    const { actions, collections, match, commonActions, common } = this.props;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      addQueryToCollectionPending,
      selectedCollection,
    } = collections;
    const { projectId, collectionId, version } = match.params;
    const { updatedCollections } = common;
    //TODO: Duplicate Code: AddCollectionDerivedField
    return (
      <CommonPageComponent parentClassName="">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            {selectedCollection && (
              <>
                <CustomFilterBuilder
                  actions={actions}
                  commonActions={commonActions}
                  projectId={projectId}
                  version={version}
                  filters={selectedCollection.finders}
                  collection={selectedCollection}
                  collections={collections}
                  showQueryCreateLoader={addQueryToCollectionPending}
                  flag={true}
                  updatedCollections={updatedCollections}
                />
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>
                      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-4 text-right">
                        <Link
                          className="btn btn-primary btn-md"
                          to={`/2.0/collections/${version}/v/${projectId}/add-item/${collectionId}`}
                          title="Goto Next Step to Add Data"
                        >
                          <i className="wb webconnect-skip-forward-fill"></i> Add Data
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <ParentDocCard>
            <h5>
              <b>About Filter</b>
            </h5>
            <p>
              Allows you to create and apply custom filters in a collection to help you filter data
              entries. You can also apply specific conditions to further manipulate a filter’s
              behaviour.
            </p>
            <br />
            <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/filters-in-collection" />
          </ParentDocCard>
        </div>

        {loadProjectCollectionsPending ||
          (loadProjectCollectionDetailPending && (
            <div className="text-center">
              <CustomLoader
                loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
                size="20px"
                color="#303453"
              />
            </div>
          ))}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCollectionFilter);
